import React from 'react'
import { Box, fade } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import Button from 'UI/Button/ButtonWithPreloader'
import { DealsStatus } from 'typescript/enums/deals'

const useDealsTableStyle = makeStyles(theme => ({
  errorButton: {
    border: `1px solid ${theme.palette.error.main}`,
    backgroundColor: fade(theme.palette.error.main, 0.05),
    color: theme.palette.error.main,
    '&:hover': {
      backgroundColor: fade(theme.palette.error.main, 0.1),
    },
  },
}))

interface DealActionButtonProps {
  dealId: number
  onStatusChange: (dealId: number, status: DealsStatus | string) => void
}

export const DealActionButton: React.FC<DealActionButtonProps> = ({ dealId, onStatusChange }) => {
  const dealsTableClasses = useDealsTableStyle()

  return (
    <Box display="flex" alignItems="center">
      <Button
        color="secondary"
        variant="outlined"
        size="small"
        onClick={() => onStatusChange(dealId, DealsStatus.approved)}
      >
        Approve
      </Button>
      <Box ml={2}>
        <Button
          onClick={() => onStatusChange(dealId, 'Declined')}
          className={dealsTableClasses.errorButton}
          color="secondary"
          variant="outlined"
          size="small"
        >
          Decline
        </Button>
      </Box>
    </Box>
  )
}
